'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobxReact = require('mobx-react');

var _ListGroup = require('react-bootstrap/lib/ListGroup');

var _ListGroup2 = _interopRequireDefault(_ListGroup);

var _CaseSearchResultsFilter = require('./CaseSearchResultsFilter');

var _CaseSearchResultsFilter2 = _interopRequireDefault(_CaseSearchResultsFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CaseSearchResultsFilterSidebar = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(CaseSearchResultsFilterSidebar, _Component);

  function CaseSearchResultsFilterSidebar() {
    _classCallCheck(this, CaseSearchResultsFilterSidebar);

    return _possibleConstructorReturn(this, (CaseSearchResultsFilterSidebar.__proto__ || Object.getPrototypeOf(CaseSearchResultsFilterSidebar)).apply(this, arguments));
  }

  _createClass(CaseSearchResultsFilterSidebar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          filterMetadata = _props.filterMetadata,
          onFilterChange = _props.onFilterChange,
          selectedFilter = _props.selectedFilter;


      return _react2.default.createElement(
        'div',
        { className: 'filter-sidebar' },
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'h3',
            null,
            'Quick Filters'
          )
        ),
        _react2.default.createElement(
          _ListGroup2.default,
          null,
          filterMetadata.map(function (filter) {
            return _react2.default.createElement(_CaseSearchResultsFilter2.default, { key: filter.name,
              filterMetaData: filter,
              onFilterChange: onFilterChange,
              active: filter.name === selectedFilter
            });
          })
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return CaseSearchResultsFilterSidebar;
}(_react.Component), _class2.defaultProps = {
  filterMetaData: [],
  selectedFilter: 'All'
}, _class2.propTypes = {
  filterMetadata: _propTypes2.default.array.isRequired,
  onFilterChange: _propTypes2.default.func.isRequired,
  selectedFilter: _propTypes2.default.string
}, _temp)) || _class) || _class;

var _default = CaseSearchResultsFilterSidebar;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CaseSearchResultsFilterSidebar, 'CaseSearchResultsFilterSidebar', '/app/src/components/page-case-search-results/CaseSearchResultsFilterSidebar.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case-search-results/CaseSearchResultsFilterSidebar.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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